import { render, staticRenderFns } from "./FgtsLookup.vue?vue&type=template&id=2622c578&scoped=true&"
import script from "./FgtsLookup.vue?vue&type=script&lang=js&"
export * from "./FgtsLookup.vue?vue&type=script&lang=js&"
import style0 from "./FgtsLookup.vue?vue&type=style&index=0&id=2622c578&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622c578",
  null
  
)

export default component.exports